import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TotalCropReport } from './Pages/listing';

export const TotalCropReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={TotalCropReport} />
    </Fragment>
)